export const HELP_ROOT = 'https://hccms.conversional.de/api'
export const MEILISEARCH_ROOT = 'https://hms.conversional.de'

export const HELP_CATEGORIES = '/help-categories'
export const HELP_ARTICLES = '/help-articles'
export const HELP_FAQS = '/faqs'
export const MEILISEARCH_MULTI_SEARCH = '/multi-search'
